import { useAppDispatch } from "../../../redux/useAppDispatch";
import { openCreateUsersModal } from "../../../redux/SettingModule/UsersPage/UsersAction";

const CreateNewUsersButton = (props: any) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <button
        className="upload-btn"
        style={{ width: "120px" }}
        onClick={() => {
          dispatch(openCreateUsersModal());
        }}>
        + Create New
      </button>
    </>
  );
};
export default CreateNewUsersButton;
